export default __webpack_public_path__ + "static/media/pillow.2c6c46e3.svg";